<template>
  <div class="comContent">
    <div class="header">
      <span class="font">发布商品</span>
      <div class="step-frame">
        <StepView :current-index="localCurrentIndex" :step-list="stepList" />
      </div>
    </div>
    <div class="centent">
      <template v-if="localCurrentIndex === 1">
        <SelectTypeView @nextStep="handleNextStep" />
      </template>
      <template v-else-if="localCurrentIndex === 2">
        <SelectProductView @preStep="handlePreStep" @nextStep="handleNextStep" />
      </template>
      <template v-else-if="localCurrentIndex === 3">
        <FillProductInfoView @preStep="handlePreStep" ref="fillProductInfo" />
      </template>
    </div>
  </div>
</template>

<script>
import StepView from "@/views/myQualification/children/step";
import SelectTypeView from "./children/SelectType.vue";
import SelectProductView from "./children/SelectProduct.vue";
import FillProductInfoView from "./children/fillProductInfo.vue";

export default {
  name:'salesControl_publish_list',
  components: {
    StepView,
    SelectTypeView,
    SelectProductView,
    FillProductInfoView,
  },
  data() {
    return {
      stepList: [
        { name: "活动类型" },
        { name: "选择商品" },
        { name: "填写商品信息" },
      ],
      localCurrentIndex: 1,
    };
  },
  computed: {
    //
  },
  watch: {},
  mounted() {
    this.initViews();
  },
  activated(){
    // console.log('刷新缓存数据接口');
    this.initViews();
    if(this.localCurrentIndex ==3){
      this.$refs['fillProductInfo'].keepAliveBack(); 
    }
  },
  methods: {
    // 读取缓存选择的活动类型，
    initViews() {
      let publicConfig = this.$store.state.publicGoods.publicConfig;
      if (publicConfig) {
        if (publicConfig.currentStep) {
          this.localCurrentIndex = publicConfig.currentStep;
        }
      }
      // console.log(publicConfig.currentStep, '---publicConfig.currentStep')
    },
    handlePreStep(index) { 
      if (index) {
        this.localCurrentIndex = 1;
        this.$store.dispatch("publicGoods/setStep", 1); 
      } else {
        this.localCurrentIndex--;
        this.$store.dispatch("publicGoods/setStep", this.localCurrentIndex);
      }

    },
    handleNextStep(val) {
      this.localCurrentIndex++;
      this.$store.dispatch("publicGoods/setStep", this.localCurrentIndex);
    },
  },
};
</script>
<style lang="scss" scoped>
.comContent {
  display: flex;
  flex-direction: column;
  padding: 0 0 24px;
}

.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f5f5;

  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }

  .step-frame {
    flex: 1;
    display: flex;
    justify-content: center;
  }
}

.centent {
  flex: 1;
  height: 0;
  overflow-y: auto;
  padding: 0 24px;
  box-sizing: border-box;
}
</style>
